import styled from "styled-components";

import { WrapperContainer } from "../../components";

export const SwitchWrapper = styled(WrapperContainer)``;

export const SwitchTitleWrapper = styled(WrapperContainer)`
  & label {
    font-size: 14px;
    line-height: 14px;
    font-weight: 500;
  }
`;
